import { render } from "./RegionStatisticsChart.vue?vue&type=template&id=37756b8d&scoped=true"
import script from "./RegionStatisticsChart.vue?vue&type=script&lang=js"
export * from "./RegionStatisticsChart.vue?vue&type=script&lang=js"

import "./RegionStatisticsChart.vue?vue&type=style&index=0&id=37756b8d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37756b8d"

export default script